import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-95b94290"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sign_wraps"
};
const _hoisted_2 = {
  class: "sign_content"
};
const _hoisted_3 = {
  class: "sign_wrap",
  id: "signWrap"
};
const _hoisted_4 = {
  class: "con_btn"
};
import { ref, onMounted, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import commonMethod from '../common/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'sign',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const image = ref('');
    const mousePressed = ref(false);
    let canvas = ref(null);
    let canvasTxt = ref(null);
    const startX = ref(0);
    const startY = ref(0);
    const moveX = ref(0);
    const moveY = ref(0);
    const fu_id = ref('');
    const sign_url = ref('');
    onMounted(() => {
      image.value = '';
      mousePressed.value = false;
      canvas.value = document.getElementById('myCanvas');
      canvasTxt.value = document.getElementById('myCanvas').getContext('2d');
      let signWrap = document.getElementById('signWrap');
      canvas.value.width = signWrap.clientWidth; // 设置宽度
      canvas.value.height = signWrap.clientHeight; // 设置高度
    });
    // 鼠标事件
    const touchStart = event => {
      if (event.targetTouches.length == 1) {
        event.preventDefault(); // 阻止浏览器默认事件，重要
        let obj = {
          x: event.targetTouches[0].clientX,
          y: event.targetTouches[0].clientY - 48
        };
        startX.value = obj.x;
        startY.value = obj.y;
        canvasTxt.value.beginPath();
        canvasTxt.value.moveTo(startX.value, startY.value);
        canvasTxt.value.lineTo(obj.x, obj.y);
        canvasTxt.value.stroke();
        canvasTxt.value.closePath();
      }
    };
    const touchMove = event => {
      if (event.targetTouches.length == 1) {
        event.preventDefault();
        let obj = {
          x: event.targetTouches[0].clientX,
          y: event.targetTouches[0].clientY - 48
        };
        moveY.value = obj.y;
        moveX.value = obj.x;
        canvasTxt.value.beginPath();
        canvasTxt.value.moveTo(startX.value, startY.value);
        canvasTxt.value.lineTo(obj.x, obj.y);
        canvasTxt.value.stroke();
        canvasTxt.value.closePath();
        startY.value = obj.y;
        startX.value = obj.x;
      }
    };
    const touchEnd = event => {
      if (event.targetTouches.length == 1) {
        event.preventDefault();
        let obj = {
          x: event.targetTouches[0].clientX,
          y: event.targetTouches[0].clientY - 48
        };
        canvasTxt.value.beginPath();
        canvasTxt.value.moveTo(startX.value, startY.value);
        canvasTxt.value.lineTo(obj.x, obj.y);
        canvasTxt.value.stroke();
        canvasTxt.value.closePath();
      }
    };
    // 清空画板
    const clearArea = () => {
      canvasTxt.value.clearRect(0, 0, canvas.value.width, canvas.value.height);
    };
    // 提交签名
    const saveSign = () => {
      checkEmpty(); // 调用 表单非空验证
    };
    const checkEmpty = () => {
      // let c = document.getElementById('myCanvas'); // 获取html的canvas对象，我这个id="myCanvas"
      if (isCanvasBlank(canvas.value)) {
        commonMethod.notify('warning', '请在签名区域签名后再次确认');
        return;
      } else {
        let image = canvas.value.toDataURL('image/png'); // 得到生成后的签名base64位  url 地址
        proxy.$api.post(`${proxy.$url}Image/saveImage`, {
          img: image
        }).then(res => {
          sign_url.value = res.data.url;
          fu_id.value = res.data.fu_id;
          window.localStorage.setItem('fu_id', fu_id.value);
          window.localStorage.setItem('sign_url', sign_url.value);
          setTimeout(() => {
            router.go(-1);
          }, 700);
        }).catch(err => {});
      }
    };
    // 验证canvas画布是否为空函数
    const isCanvasBlank = canvas => {
      let blank = document.createElement('canvas'); // 系统获取一个空canvas对象
      blank.width = canvas.width;
      blank.height = canvas.height;
      return canvas.toDataURL() == blank.toDataURL(); // 比较值相等则为空
    };
    // 返回上一页
    const back = () => {
      window.history.go(-1);
    };
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_nav_bar, {
        title: "上传签名",
        "left-arrow": "",
        border: "",
        fixed: "",
        placeholder: "",
        onClickLeft: back
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("canvas", {
        id: "myCanvas",
        onTouchstart: touchStart,
        onTouchmove: touchMove,
        onTouchend: touchEnd
      }, null, 32)])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_button, {
        class: "staging_btn",
        round: "",
        plain: "",
        onClick: _cache[0] || (_cache[0] = $event => clearArea())
      }, {
        default: _withCtx(() => [_createTextVNode("清除签名")]),
        _: 1
      }), _createVNode(_component_van_button, {
        round: "",
        color: "#b50029",
        onClick: _cache[1] || (_cache[1] = $event => saveSign())
      }, {
        default: _withCtx(() => [_createTextVNode("确认签名")]),
        _: 1
      })])])], 64);
    };
  }
});